import React, { useEffect, useRef, useState } from 'react';
import { Storage, Translate, translate, ValidatedField } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import { Button } from 'reactstrap';
import FormHelperText from '@mui/material/FormHelperText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateEntity as updateBank } from 'app/entities/bank/bank.reducer';

export function QuotationSetting() {
  const dispatch = useAppDispatch();
  const account = useAppSelector(state => state.authentication.account);
  const bankEntity = useAppSelector(state => state.bank.entity);

  const userRoleAccessList = useAppSelector(state => state.userManagement.userRoleAccessList);
  const isUserAuthorizedToEdit = userRoleAccessList.length === 0 || userRoleAccessList.some(role => role.bankId === bankEntity?.id);
  const [localQuotationValidityCollapse, setLocalQuotationValidityCollapse] = React.useState(true);
  const [valueQuotationValidityDays, setValueQuotationValidityDays] = React.useState('');
  const [valueQuotationMaxExtensionDays, setValueQuotationMaxExtensionDays] = React.useState('');
  const [valueQuotationMaxEditableDays, setValueQuotationMaxEditableDays] = useState('');

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorMessageMaxExtension, setErrorMessageMaxExtension] = useState<string | null>(null);
  const [errorMessageMaxEditable, setErrorMessageMaxEditable] = useState<string | null>(null);

  const handleLocalQuotationValidityCollapse = () => {
    setLocalQuotationValidityCollapse(prev => !prev);
  };

  const handleValueQuotationValidityDays = event => {
    const changeQuotationValidityDays = event.target.value;
    setValueQuotationValidityDays(changeQuotationValidityDays);
    if (changeQuotationValidityDays === '0') {
      setErrorMessage(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
    } else {
      setErrorMessage(null);
    }
  };

  const handleQuotationValueMaxExtensionDays = event => {
    const changeQuotationMaxExtensionDays = event.target.value;
    setValueQuotationMaxExtensionDays(changeQuotationMaxExtensionDays);
    if (changeQuotationMaxExtensionDays === '0') {
      setErrorMessageMaxExtension(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
    } else {
      setErrorMessageMaxExtension(null);
    }
  };

  const handleQuotationValueMaxEditableDays = event => {
    const value = event.target.value;
    setValueQuotationMaxEditableDays(value);
    if (value === '0') {
      setErrorMessageMaxEditable(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
    } else {
      setErrorMessageMaxEditable(null);
    }
  };

  const handleLocalQuotationValiditySettings = () => {
    const updatedBank = {
      ...bankEntity,
      quotationValidityDays: valueQuotationValidityDays ? Number(valueQuotationValidityDays) : null,
      quotationMaxExtensionDays: valueQuotationMaxExtensionDays ? Number(valueQuotationMaxExtensionDays) : null,
      quotationMaxEditableDays: valueQuotationMaxEditableDays ? Number(valueQuotationMaxEditableDays) : null,
    };
    dispatch(updateBank(updatedBank));
  };

  useEffect(() => {
    if (errorMessage) {
      setErrorMessage(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
    }
    if (errorMessageMaxExtension) {
      setErrorMessageMaxExtension(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
    }
    if (errorMessageMaxEditable) {
      setErrorMessageMaxEditable(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
    }
  }, [Storage.session.get('locale'), errorMessage, errorMessageMaxExtension, errorMessageMaxEditable]);

  useEffect(() => {
    if (bankEntity?.id !== undefined) {
      if (bankEntity?.quotationValidityDays !== null && bankEntity?.quotationValidityDays !== undefined) {
        setValueQuotationValidityDays(bankEntity.quotationValidityDays.toString());
      }

      if (bankEntity?.quotationMaxExtensionDays !== null && bankEntity?.quotationMaxExtensionDays !== undefined) {
        setValueQuotationMaxExtensionDays(bankEntity.quotationMaxExtensionDays.toString());
      }
      if (bankEntity?.quotationMaxEditableDays != null && bankEntity?.quotationMaxEditableDays !== undefined) {
        setValueQuotationMaxEditableDays(bankEntity.quotationMaxEditableDays.toString());
      }
    }
  }, [bankEntity]);

  const isSaveDisabled = !isUserAuthorizedToEdit || !!errorMessage || !!errorMessageMaxExtension || !!errorMessageMaxEditable;

  return (
    <div className="collapse-section">
      <Grid container className="align-items-center">
        <Grid item xs={10} sm={11} md={11.5}>
          <Typography variant="h5" component="div" data-cy="localQuotationValidityHeading">
            {translate('comexApp.bank.details.localQuotationValidity.title')}
          </Typography>
        </Grid>
        <Grid item xs={2} sm={1} md={0.5}>
          <IconButton aria-label="collapse" onClick={handleLocalQuotationValidityCollapse}>
            {localQuotationValidityCollapse ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={localQuotationValidityCollapse}>
        <br />
        <ValidatedField
          label={translate('comexApp.bank.details.localQuotationValidity.noOfDays')}
          id="quotationValidityDays"
          name="quotationValidityDays"
          data-cy="quotationValidityDays"
          type="text"
          value={valueQuotationValidityDays}
          onChange={handleValueQuotationValidityDays}
          onInput={e => {
            const input = e.target as HTMLInputElement;
            if (input.value === '0') {
              setErrorMessage(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
            }
            input.value = input.value.replace(/\D/g, '');
          }}
          pattern="[0-9]*"
          inputMode="numeric"
          min="1"
          disabled={!isUserAuthorizedToEdit}
        />
        {errorMessage && (
          <FormHelperText
            error
            sx={{
              textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left',
            }}
          >
            {errorMessage}
          </FormHelperText>
        )}
        <br />
        <ValidatedField
          label={translate('comexApp.bank.details.localQuotationValidity.maxExtensionDays')}
          id="quotationMaxExtensionDays"
          name="quotationMaxExtensionDays"
          data-cy="quotationMaxExtensionDays"
          type="text"
          value={valueQuotationMaxExtensionDays}
          onChange={handleQuotationValueMaxExtensionDays}
          onInput={e => {
            const input = e.target as HTMLInputElement;
            if (input.value === '0') {
              setErrorMessageMaxExtension(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
            }
            input.value = input.value.replace(/\D/g, '');
          }}
          pattern="[0-9]*"
          inputMode="numeric"
          min="1"
          disabled={!isUserAuthorizedToEdit}
        />
        {errorMessageMaxExtension && (
          <FormHelperText
            error
            sx={{
              textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left',
            }}
          >
            {errorMessageMaxExtension}
          </FormHelperText>
        )}
        <br />
        <ValidatedField
          label={translate('comexApp.bank.details.localQuotationValidity.maxEditableDays')}
          id="quotationMaxEditableDays"
          name="quotationMaxEditableDays"
          data-cy="quotationMaxEditableDays"
          type="text"
          value={valueQuotationMaxEditableDays}
          onChange={handleQuotationValueMaxEditableDays}
          onInput={e => {
            const input = e.target as HTMLInputElement;
            if (input.value === '0') {
              setErrorMessageMaxEditable(translate('comexApp.bank.details.localQuotationValidity.noOfDaysMessage'));
            }
            input.value = input.value.replace(/\D/g, '');
          }}
          pattern="[0-9]*"
          inputMode="numeric"
          min="1"
          disabled={!isUserAuthorizedToEdit}
        />
        {errorMessageMaxEditable && (
          <FormHelperText
            error
            sx={{
              textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left',
            }}
          >
            {errorMessageMaxEditable}
          </FormHelperText>
        )}
        <br />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button color="primary" onClick={handleLocalQuotationValiditySettings} value={0} disabled={isSaveDisabled}>
            <FontAwesomeIcon icon="plus" /> <Translate contentKey="comexApp.bank.details.update" />
          </Button>
        </Box>
      </Collapse>
    </div>
  );
}
